import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CharLength } from '../../../../modules/directives/char-length.directive';

@Component({
  selector: 'app-directors-step',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CharLength],
  templateUrl: './directors-step.component.html',
})
export class DirectorsStepComponent {
  @Input({ required: true }) directors!: FormArray<FormGroup>;
  @Input() busyVerify: Record<number, boolean> = {};
  @Input() duplicateModalMessage: string | null = null;
  @Output() addDirector = new EventEmitter<void>();
  @Output() removeDirector = new EventEmitter<number>();
  @Output() verifyAsin = new EventEmitter<number>();
  @Output() closeDuplicateModal = new EventEmitter<void>();

  trackByIndex(index: number): number {
    return index;
  }

  hasGroupError(group: FormGroup, controlName: string): boolean {
    const control = group.get(controlName);
    return !!control && control.invalid && (control.touched || control.dirty);
  }

  isAsinVerified(group: FormGroup): boolean {
    return !!group.get('asinVerified')?.value;
  }
}
